export class ConfiguracoesProjeto {
    public production: boolean;
    public ambiente: string;
    public recaptcha: string;
    public uri: string;
    public uri_docsnbp: string;
    public refresh_token_base: number;
    public uri_termo_lgpd: string;
    public youtube_channel_id: string;
    public youtube_playlist_id: string;
    public youtube_token: string;
    public youtube_google_key: string;
    public url_inicio_portal_frontend: string;
    public url_cadastro_portal_frontend: string;
    public url_logout_gov_br: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/configuracoes-projeto.model.ts